import { REACT_APP_API_ABM } from '../../config'
import axios from 'axios'

export async function getBusinessUnits() {
    const response = await axios.get(`${REACT_APP_API_ABM}/UnitBussiness`)
    if (response.status === 200) {
        return response.data?.data
    }
    return null

}